module.exports = __webpack_public_path__ + "static/media/le-malin-lose.be790e68.png";